import { useEffect, useState, useRef } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { createMultipleRef, getValueInputRef } from '../../../helpers'
import { Modal, Input, Select, ModalAlert } from '../../../components'
import { CommonService, ShiptoService } from "../../../services";
import { get, isEmpty } from 'lodash'
import { BASE_URL } from '../../../AppConfig'
import { TimePicker, InputNumber } from 'antd';
import dayjs from 'dayjs';

const format = 'HH:mm';
let firstRender = false
const Shipto = inject("masterStore", "authenStore")(observer((props) => {
  let masterStore = props.masterStore
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  let { setMasterStore } = masterStore
  const [modalConfig, setModalConfig]: any = useState({
    show: false,
    action: "",
    id: ""
  })
  const [loading, setLoading]: any = useState(false)
  const [optionStatus, setOptionStatus] = useState([])
  const [optionCustomer, setOptionCustomer] = useState([])
  const [optionProvince, setOptionProvince] = useState([])
  const [optionDistrict, setOptionDistrict] = useState([])
  const [optionZone, setOptionZone] = useState([])
  const [optionSubDistrict, setOptionSubDistrict] = useState([])
  const [validation, setValidation]: any = useState({})
  const [shakeIsWrong, setShakeIsWrong] = useState(false)
  const [dataForm, setDataForm]: any = useState({
    id: "",
    cust_id: "",
    shipto_name: "",
    lat: "",
    lon: "",
    address: "",
    village: "",
    soi: "",
    road: "",
    admin_level1_id: "",
    admin_level2_id: "",
    admin_level3_id: "",
    post_code: "",
    tel: "",
    // taxid: "",
    ref_code: "",
    dtopen: "",
    dtclose: "",
    pickup_mins: 0,
    pickdown_mins: 0,
    status: "Y",
    zone_id: ""
    // zone_code: ""
  })
  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: [],

    }
  })
  const inputRef: any = useRef([]);
  createMultipleRef(inputRef, 7)

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status,customer,admin_level1")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          let customer = res.result.customer.map((item) => ({ label: item.cust_name, value: item.cust_id }))
          let admin_level1 = res.result.admin_level1.map((item) => ({ label: item.admin_level1_name, value: item.admin_level1_id }))

          setOptionStatus(common_status)
          setOptionCustomer(customer)
          setOptionProvince(admin_level1)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  const getAddressMaster = (id_ref1, id_ref2) => { // GET ADDRESS MASTER 
    CommonService.getMasterData(auth, "admin_level1,admin_level2,admin_level3", id_ref1, id_ref2)
      .then((res: any) => {
        let admin_level1 = res.result.admin_level1.map((item) => ({ label: item.admin_level1_name, value: item.admin_level1_id }))
        let admin_level2 = res.result.admin_level2.map((item) => ({ label: item.admin_level2_name, value: item.admin_level2_id }))
        let admin_level3 = res.result.admin_level3.map((item) => ({ label: item.admin_level3_name, value: item.admin_level3_id }))
        setOptionProvince(admin_level1)
        setOptionDistrict(admin_level2)
        setOptionSubDistrict(admin_level3)
      })
      .catch((err) => {
        console.log(`Load master data : ${err}`)
      })
  }

  const onChangeProvince = (id_ref1) => { // GET MASTER DISTRICT
    if (id_ref1) {
      setDataForm({ ...dataForm, admin_level1_id: id_ref1 })
      CommonService.getMasterData(auth, "admin_level2", id_ref1)
        .then((res: any) => {
          let admin_level2 = res.result.admin_level2.map((item) => ({ label: item.admin_level2_name, value: item.admin_level2_id }))
          setOptionDistrict(admin_level2)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else {
      setDataForm({ ...dataForm, admin_level1_id: "", admin_level2_id: "", admin_level3_id: "" })
      setOptionDistrict([])
    }
  }

  const onChangeDistrict = (id_ref2) => { // GET MASTER DISTRICT
    if (id_ref2) {
      setDataForm({ ...dataForm, admin_level2_id: id_ref2 })
      CommonService.getMasterData(auth, "admin_level3", dataForm.admin_level1_id, id_ref2)
        .then((res: any) => {
          let admin_level3 = res.result.admin_level3.map((item) => ({ label: item.admin_level3_name, value: item.admin_level3_id }))
          setOptionSubDistrict(admin_level3)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else {
      setDataForm({ ...dataForm, admin_level2_id: "", admin_level3_id: "" })
      setOptionSubDistrict([])
    }
  }

  const getZone = (cust_id) => { // GET ZONE
    CommonService.getMasterData(auth, "zone", cust_id)
      .then((res: any) => {
        let zone = res.result.zone.map((item) => ({ label: item.zone_name, value: item.zone_id }))
        let existsCustomer = zone.find((d) => d.value === cust_id)

        if (!existsCustomer) {
          setDataForm({ ...dataForm, zone_id: "", cust_id })
        }

        setOptionZone(zone)
      })
      .catch((err) => {
        console.log(`Load master zone : ${err}`)
      })
  }

  //#region 
  const onSave = () => {
    let validateCheck = {}, message = { isError: true, message: "โปรดระบุ" }
    let formData = getValueInputRef(inputRef)

    if (dataForm.cust_id.length === 0 || dataForm.cust_id === "")
      validateCheck['cust_id'] = message
    if (formData.shipto_name.trim() === "")
      validateCheck['shipto_name'] = message
    if (formData.lat.trim() === "")
      validateCheck['lat'] = message
    if (formData.lon.trim() === "")
      validateCheck['lon'] = message
    if (dataForm.zone_id.length === 0 || dataForm.zone_id === "")
      validateCheck['zone_id'] = message

    if (isEmpty(validateCheck)) {
      setValidation({})
      setOptionAlert({
        ...optionAlert,
        action: {
          id: dataForm.id,
          name: dataForm.id === "" ? 'create' : 'update'
        },
        type: "confirm",
        title: "ยืนยัน",
        show: true,
        description: {
          visible: true,
          type: "text",
          content: "คุณแน่ใจที่จะบันทึกข้อมูล ?",
          contentLists: []
        }
      })
    }
    else {
      setValidation(validateCheck)
      setShakeIsWrong(true)
      setTimeout(() => setShakeIsWrong(false), 100);
    }
  }

  const saveData = () => {
    let formData = getValueInputRef(inputRef)

    let body = {
      cust_id: dataForm.cust_id,
      shipto_name: formData.shipto_name,
      shipto_code: formData.shipto_code,
      lat: formData.lat,
      lon: formData.lon,
      address: formData.address,
      village: formData.village,
      soi: formData.soi,
      road: formData.road,
      admin_level1_id: dataForm.admin_level1_id === "" ? 0 : dataForm.admin_level1_id,
      admin_level2_id: dataForm.admin_level2_id === "" ? 0 : dataForm.admin_level2_id,
      admin_level3_id: dataForm.admin_level3_id === "" ? 0 : dataForm.admin_level3_id,
      post_code: formData.post_code,
      tel: formData.tel,
      ref_code: formData.ref_code,
      dtopen: dataForm.dtopen,
      dtclose: dataForm.dtclose,
      pickup_mins: dataForm.pickup_mins,
      pickdown_mins: dataForm.pickdown_mins,
      status: dataForm.status,
      zone_id: dataForm.zone_id
    }

    if (optionAlert.action.name === "create") {
      ShiptoService.addShipto(auth, body)
        .then((res: any) => {
          let { code, message } = res.data
          if (code === 200) {
            setOptionAlert({
              ...optionAlert,
              type: "success",
              show: true,
              action: {
                id: "",
                name: ""
              },
              title: "บันทึกข้อมูลสำเร็จ",
              description: { visible: false, type: "text", content: " ", contentLists: [] }
            })
            setMasterStore({ isRefreshData: true })
            clearDataForm()
            setModalConfig({ ...modalConfig, show: false })
          }
          else {
            setOptionAlert({
              ...optionAlert,
              type: "danger",
              show: true,
              action: {
                id: "",
                name: ""
              },
              title: "ผิดพลาด",
              description: { visible: true, type: "text", content: message }
            })
          }
          setLoading(false)

        })
        .catch((err) => {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${err}` }
          })
          setLoading(false)
        })
    }
    else {
      ShiptoService.updateShipto(auth, {
        ...body,
        shipto_id: dataForm.id
      })
        .then((res: any) => {
          let { code, message } = res.data
          if (code === 200) {
            setOptionAlert({
              ...optionAlert,
              type: "success",
              show: true,
              action: {
                id: "",
                name: ""
              },
              title: "บันทึกข้อมูลสำเร็จ",
              description: { visible: false, type: "text", content: " ", contentLists: [] }
            })
            setMasterStore({ isRefreshData: true })
            clearDataForm()
            setModalConfig({ ...modalConfig, show: false })
          }
          else {
            setOptionAlert({
              ...optionAlert,
              type: "danger",
              show: true,
              action: {
                id: "",
                name: ""
              },
              title: "ผิดพลาด",
              description: { visible: true, type: "text", content: message }
            })
          }
          setLoading(false)

        })
        .catch((err) => {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${err}` }
          })
          setLoading(false)
        })
    }

  }
  //#endregion

  const clearDataForm = () => {
    setValidation({})
    setDataForm({
      id: "",
      cust_id: "",
      shipto_name: "",
      lat: "",
      lon: "",
      address: "",
      village: "",
      soi: "",
      road: "",
      admin_level1_id: "",
      admin_level2_id: "",
      admin_level3_id: "",
      post_code: "",
      tel: "",
      ref_code: "",
      dtopen: "",
      dtclose: "",
      pickup_mins: 0,
      pickdown_mins: 0,
      status: "Y",
      zone_id: ""
      // zone_code: ""
    })
  }

  return <>
    <ModalAlert
      {...optionAlert}
      onOk={() => {
        let { action } = optionAlert
        if (["create", "update"].includes(action.name)) {
          setLoading(true)
          saveData()
        }

        setOptionAlert({ ...optionAlert, show: false })
      }}
      onCancel={() => {
        setOptionAlert({ ...optionAlert, show: false })
      }}
    />

    <FormMaster
      title="ข้อมูลจัดส่งปลายทาง"
      tableConfig={{
        key: "id",
        apiPath: "shipto/list",
        allowDelete: {
          visible: true,
          key: "shipto_id",
          apiPath: "shipto/delete",
          paramType: 'param'
        },
        optionDeleteFag: true,
        defaultColumn: [],
        columns: [
          {
            dataField: 'no',
            caption: "ลำดับ",
            width: 60,
            alignment: "center",
            allowFiltering: false
          },
          {
            dataField: 'cust_name',
            caption: "ชื่อลูกค้า",
            allowFiltering: true
          },
          {
            dataField: 'shipto_code',
            caption: "รหัสจัดส่งปลายทาง",
            allowFiltering: true
          },
          {
            dataField: 'shipto_name',
            caption: "สถานที่ส่งสินค้า",
            allowFiltering: true
          },
          {
            dataField: 'address',
            caption: "ที่อยู่"
          },
          {
            dataField: 'shipto_name',
            caption: "พิกัด",
            cellRender: (e) => {
              let data = e.row.data
              return `${data.lat}, ${data.lon}`
            }
          },
          {
            dataField: 'status_name',
            caption: "สถานะ",
            allowFiltering: true
          },
          {
            dataField: 'updated_by',
            caption: "แก้ไขโดย"
          }
        ],
        exportExcel: {
          fileName: 'ข้อมูลจัดส่งปลายทาง',
          columnConfig: [
            { label: 'ลำดับ', value: 'no' },
            { label: 'ชื่อลูกค้า', value: 'cust_name' },
            { label: 'รหัสจัดส่งปลายทาง', value: 'shipto_code' },
            { label: 'สถานที่ส่งสินค้า', value: 'shipto_name' },
            { label: 'ที่อยู่', value: 'address' },
            { label: 'ชื่อโครงการ', value: 'village' },
            { label: 'ซอย', value: 'soi' },
            { label: 'ถนน', value: 'road' },
            { label: 'ตำบล', value: 'admin_level3_name' },
            { label: 'อำเภอ', value: 'admin_level2_name' },
            { label: 'จังหวัด', value: 'admin_level1_name' },
            { label: 'รหัสไปรษณีย์', value: 'post_code' },
            { label: 'เบอร์โทร', value: 'tel' },
            { label: 'เลขอ้างอิง', value: 'ref_code' },
            { label: 'พิกัด', value: (col) => (`${col.lat}, ${col.lon}`) },
            { label: 'เวลาเปิด', value: 'dtopen' },
            { label: 'เวลาปิด', value: 'dtclose' },
            { label: 'ระยะเวลาโหลดสินค้า (นาที)', value: 'pickup_mins' },
            { label: 'ระยะเวลาลงสินค้า (นาที)', value: 'pickdown_mins' },
            { label: 'สถานะ', value: 'status_name' },
            { label: 'แก้ไขโดย', value: 'updated_by' }
          ]
        }
      }}
      formData={{
        cust_id: "",
        shipto_name: "",
        address: "",
        village: "",
        soi: "",
        road: "",
        admin_level1_id: "",
        admin_level2_id: "",
        admin_level3_id: "",
        post_code: "",
        tel: "",
        // taxid: "",
        ref_code: "",
        dtopen: "00:00",
        dtclose: "00:00",
        pickup_mins: "",
        pickdown_mins: ""
      }}
      modalConfig={{
        visible: false,
        title: "พนักงานขับรถ",
        required: [],
        fieldTypeNumber: [],
        paramName: "shipto_id",
        apiPath: {
          "get": '',
          "post": 'shipto/add',
          "put": 'shipto/update'
        },
        elements: []
      }}
      onAdd={(data) => {
        setModalConfig(data.modalConfig)
      }}
      onEdit={(data) => {
        setModalConfig(data.modalConfig)

        let dt = data.modalConfig.dataSelectRow
        getAddressMaster(dt.admin_level1_id, dt.admin_level2_id)
        getZone(dt.cust_id)
        setTimeout(() => {
          setDataForm({
            ...dataForm,
            id: dt.id,
            cust_id: dt.cust_id,
            shipto_name: dt.shipto_name,
            shipto_code: dt.shipto_code,
            lat: dt.lat,
            lon: dt.lon,
            address: dt.address,
            village: dt.village,
            soi: dt.soi,
            road: dt.road,
            admin_level1_id: dt.admin_level1_id === 0 ? "" : dt.admin_level1_id,
            admin_level2_id: dt.admin_level2_id === 0 ? "" : dt.admin_level2_id,
            admin_level3_id: dt.admin_level3_id === 0 ? "" : dt.admin_level3_id,
            post_code: dt.post_code,
            tel: dt.tel,
            ref_code: dt.ref_code,
            dtopen: dt.dtopen,
            dtclose: dt.dtclose,
            pickup_mins: dt.pickup_mins,
            pickdown_mins: dt.pickdown_mins,
            status: dt.status,
            zone_id: dt.zone_id,
            // zone_code: dt.zone_code,
          })
        }, 500);
      }}
    />

    <Modal
      title={{ text: `${modalConfig.action === 'add' ? 'เพิ่ม' : 'แก้ไข'}จัดส่งปลายทาง` }}
      open={modalConfig.show}
      maskClosable={true}
      shake={shakeIsWrong}
      onClosed={() => {
        clearDataForm()
        setModalConfig({ ...modalConfig, show: false })
      }}
      onOk={() => onSave()}
    >
      <div className='md:space-y-2'>
        <div className='flex md:flex-row sm:flex-col xs:flex-col md:space-x-4'>
          <div className='flex-1'>
            <Select
              showSearch={true}
              label="ชื่อลูกค้า"
              placeholder="ชื่อลูกค้า"
              validate={validation['cust_id']}
              defaultValue={dataForm.cust_id}
              required={true}
              options={optionCustomer}
              onChange={(value) => {
                getZone(value)
                setDataForm({ ...dataForm, cust_id: value })
              }}
            />
          </div>
        </div>
        <div className='flex md:flex-row sm:flex-col xs:flex-col md:space-x-4'>
          <div className='flex-1'>
            <Input
              id="shipto_code"
              label="รหัสจัดส่งปลายทาง"
              placeholder="รหัสจัดส่งปลายทาง"
              defaultValue={dataForm.shipto_code}
              onRef={(ref) => inputRef.current[10] = ref}
            />
          </div>

          <div className='flex-1'>
            <Input
              id="shipto_name"
              label="ชื่อสถานที่ส่งสินค้า"
              placeholder="ชื่อสถานที่ส่งสินค้า"
              required={true}
              validate={validation['shipto_name']}
              defaultValue={dataForm.shipto_name}
              onRef={(ref) => inputRef.current[0] = ref}
            />
          </div>
        </div>

        <div className='flex md:flex-row sm:flex-col xs:flex-col md:space-x-4'>
          <div className='flex-1'>
            <Input
              id="lat"
              label="ละติจูด"
              placeholder="ละติจูด"
              validate={validation['lat']}
              defaultValue={dataForm.lat}
              required={true}
              onRef={(ref) => inputRef.current[7] = ref}
            />
          </div>

          <div className='flex-1'>
            <Input
              id="lon"
              label="ลองติจูด"
              placeholder="ลองติจูด"
              validate={validation['lon']}
              defaultValue={dataForm.lon}
              required={true}
              onRef={(ref) => inputRef.current[9] = ref}
            />
          </div>
        </div>

        <div className='flex md:flex-row sm:flex-col xs:flex-col md:space-x-4'>
          <div className='flex-1'>
            <Input
              id="address"
              label="ที่อยู่"
              placeholder="ที่อยู่"
              validate={validation['address']}
              defaultValue={dataForm.address}
              onRef={(ref) => inputRef.current[1] = ref}
            />
          </div>

          <div className='flex-1'>
            <Input
              id="village"
              label="ชื่อโครงการ/อาคาร"
              placeholder="ชื่อโครงการ/อาคาร"
              validate={validation['village']}
              defaultValue={dataForm.village}
              onRef={(ref) => inputRef.current[2] = ref}
            />
          </div>
        </div>

        <div className='flex md:flex-row sm:flex-col xs:flex-col md:space-x-4'>
          <div className='flex-1'>
            <Input
              id="soi"
              label="ซอย"
              placeholder="ซอย"
              validate={validation['soi']}
              defaultValue={dataForm.soi}
              onRef={(ref) => inputRef.current[3] = ref}
            />
          </div>

          <div className='flex-1'>
            <Input
              id="road"
              label="ถนน"
              placeholder="ถนน"
              validate={validation['road']}
              defaultValue={dataForm.road}
              onRef={(ref) => inputRef.current[4] = ref}
            />
          </div>
        </div>

        <div className='flex md:flex-row sm:flex-col xs:flex-col md:space-x-4'>
          <div className='flex-1'>
            <Select
              allowClear={true}
              showSearch={true}
              label="จังหวัด"
              placeholder="จังหวัด"
              validate={validation['admin_level1_id']}
              defaultValue={dataForm.admin_level1_id}
              options={optionProvince}
              onChange={(value) => onChangeProvince(value)}
            />
          </div>

          <div className='flex-1'>
            <Select
              showSearch={true}
              allowClear={true}
              label="อำเภอ"
              placeholder="อำเภอ"
              validate={validation['admin_level2_id']}
              defaultValue={dataForm.admin_level2_id}
              disabled={dataForm.admin_level1_id === "" ? true : false}
              options={optionDistrict}
              onChange={(value) => onChangeDistrict(value)}
            />
          </div>
        </div>

        <div className='flex md:flex-row sm:flex-col xs:flex-col md:space-x-4'>
          <div className='flex-1'>
            <Select
              showSearch={true}
              allowClear={true}
              label="ตำบล"
              placeholder="ตำบล"
              validate={validation['admin_level3_id']}
              defaultValue={dataForm.admin_level3_id}
              disabled={dataForm.admin_level2_id === "" ? true : false}
              options={optionSubDistrict}
              onChange={(value) => setDataForm({ ...dataForm, admin_level3_id: value ? value : '' })}
            />
          </div>

          <div className='flex-1'>
            <Input
              id="post_code"
              label="รหัสไปรษณีย์"
              placeholder="รหัสไปรษณีย์"
              validate={validation['post_code']}
              defaultValue={dataForm.post_code}
              onRef={(ref) => inputRef.current[5] = ref}
            />
          </div>
        </div>

        <div className='flex md:flex-row sm:flex-col xs:flex-col md:space-x-4'>
          <div className='flex-1'>
            <Input
              id="tel"
              label="เบอร์โทร"
              placeholder="เบอร์โทร"
              validate={validation['tel']}
              defaultValue={dataForm.tel}
              onRef={(ref) => inputRef.current[6] = ref}
            />
          </div>

          <div className='flex-1'>
            <Input
              id="ref_code"
              label="เลขอ้างอิง"
              placeholder="เลขอ้างอิง"
              validate={validation['ref_code']}
              defaultValue={dataForm.ref_code}
              onRef={(ref) => inputRef.current[8] = ref}
            />
          </div>
        </div>

        <div className='flex md:flex-row sm:flex-col xs:flex-col md:space-x-4'>
          <div className='flex-1'>
            <div className={`flex justify-between`}>
              <label htmlFor="email" className={`flex flex-row text-sm font-medium text-gray-700 dark:text-gray-200`}>
                เวลาเปิด
              </label>
            </div>
            <div className="mt-1">
              <TimePicker
                style={{ width: "100%" }}
                placeholder="เวลาเปิด"
                value={dataForm.dtopen && dayjs(dataForm.dtopen, format)}
                onChange={(time) => {
                  let timeValue = time ? time?.format(format) : ""
                  setDataForm({ ...dataForm, dtopen: timeValue })
                }}
                format={format} />
            </div>
          </div>

          <div className='flex-1'>
            <div className={`flex justify-between`}>
              <label htmlFor="email" className={`flex flex-row text-sm font-medium text-gray-700 dark:text-gray-200`}>
                เวลาปิด
              </label>
            </div>
            <div className="mt-1">
              <TimePicker
                style={{ width: "100%" }}
                placeholder="เวลาปิด"
                value={dataForm.dtclose && dayjs(dataForm.dtclose, format)}
                onChange={(time) => {
                  let timeValue = time ? time?.format(format) : ""
                  setDataForm({ ...dataForm, dtclose: timeValue })
                }}
                format={format} />
            </div>
          </div>
        </div>

        <div className='flex md:flex-row sm:flex-col xs:flex-col md:space-x-4'>
          <div className='flex-1'>
            <div className={`flex justify-between`}>
              <label htmlFor="email" className={`flex flex-row text-sm font-medium text-gray-700 dark:text-gray-200`}>
                ระยะเวลาการโหลดสินค้า (นาที)
              </label>
            </div>
            <div className="mt-1">
              <InputNumber
                min={0}
                value={dataForm.pickup_mins}
                placeholder="ระยะเวลาการโหลดสินค้า (นาที)"
                style={{ width: "100%" }}
                onChange={(number) => setDataForm({ ...dataForm, pickup_mins: number })}
              />
            </div>
          </div>

          <div className='flex-1'>
            <div className={`flex justify-between`}>
              <label htmlFor="email" className={`flex flex-row text-sm font-medium text-gray-700 dark:text-gray-200`}>
                ระยะเวลาการลงสินค้า (นาที)
              </label>
            </div>
            <div className="mt-1">
              <InputNumber
                min={0}
                value={dataForm.pickdown_mins}
                placeholder="ระยะเวลาการลงสินค้า (นาที)"
                style={{ width: "100%" }}
                onChange={(number) => setDataForm({ ...dataForm, pickdown_mins: number })}
              />
            </div>
          </div>
        </div>

        <div className='flex md:flex-row sm:flex-col xs:flex-col md:space-x-4'>
          <div className='flex-1'>
            <Select
              label="สถานะ"
              placeholder="สถานะ"
              defaultValue={dataForm.status}
              options={optionStatus}
              onChange={(value) => setDataForm({ ...dataForm, status: value })}
            />
          </div>
          <div className='flex-1'>
            <Select
              showSearch={true}
              label="โซน"
              placeholder="โซน"
              required={true}
              validate={validation['zone_id']}
              defaultValue={dataForm.zone_id}
              options={optionZone}
              onChange={(value) => setDataForm({ ...dataForm, zone_id: value })}
            />
            {/* {
              modalConfig.action === 'edit' && <Input
                id="zone_code"
                label="รหัสโซน"
                placeholder="รหัสโซน"
                disabled={true}
                defaultValue={dataForm.zone_code}
              />
            } */}
          </div>
        </div>
      </div>
    </Modal>
  </>
}))

export default Shipto